export { DiversityPageBannerSection } from "./DiversityPageBannerSection";
export { DiversityPageContentSection } from "./DiversityPageContentSection";
export { DiversityPageOfferingsSection } from "./DiversityPageOfferingsSection";
export { DiversityPageProgrammeOneSection } from "./DiversityPageProgrammeOneSection";
